/* Marinelie — Der schwebende Kauf-Container.
   Läuft auf jeder Produktseite: zeigt die Leiste, sobald die Kaufbox der
   Seite aus dem Bild gescrollt ist, und versteckt sie wieder, sobald der Fuß
   im Bild steht (dort stehen die rechtlichen Links). Vor dem Absenden holt
   sie die aktuell gewählte Variante aus dem Formular der Seite — so kauft
   die Leiste immer das, was oben ausgewählt ist. */
(function () {
  'use strict';

  function start() {
    var schweben = document.querySelectorAll('[data-ml-ks]');
    if (!schweben.length) return;

    /* Das Formular der Seite: das erste Warenkorb-Formular, das nicht in der
       schwebenden Leiste selbst steckt. */
    function seitenFormular() {
      var alle = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < alle.length; i++) {
        if (!alle[i].closest('[data-ml-ks]')) return alle[i];
      }
      return null;
    }

    /* Der Anker, an dem die Leiste hängt: die Frost-Buybox der V4-Seite,
       sonst ein ausdrücklich gesetzter Anker, sonst das Formular der Seite. */
    var anker = document.querySelector('.mlp4__frost')
      || document.querySelector('[data-ml-ks-anker]')
      || seitenFormular();

    /* Custom Set: die Leiste hat ein eigenes Formular ohne die Duefte.
       Sie kam darum ohne Wahl in den Korb (Otton, 17.10.2026: "kein sticky
       add to cart, solange nicht ausgewaehlt wurde"). Sie erscheint erst,
       wenn die Duftwahl voll ist, und schickt dann deren Formular ab. */
    var duftwahl = document.querySelector('ml-duftwahl');

    var boxWeg = false;
    var fussDa = false;
    var stellen = function () {
      var frei = !duftwahl || duftwahl.hasAttribute('data-dw-voll');
      for (var i = 0; i < schweben.length; i++) {
        schweben[i].hidden = false;
        schweben[i].classList.toggle('is-da', boxWeg && !fussDa && frei);
      }
    };
    if (duftwahl) document.addEventListener('ml:duftwahl', stellen);

    if (anker && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        boxWeg = !eintraege[0].isIntersecting;
        stellen();
      }, { threshold: 0 }).observe(anker);

      var fuss = document.querySelector('.ml-fussbereich') || document.querySelector('footer');
      if (fuss) {
        new IntersectionObserver(function (eintraege) {
          fussDa = eintraege[0].isIntersecting;
          stellen();
        }, { threshold: 0 }).observe(fuss);
      }
    } else {
      /* Ohne Anker oder ohne Observer: nach einer Bildschirmhöhe einblenden. */
      var pruefen = function () {
        boxWeg = window.pageYOffset > window.innerHeight * 0.7;
        stellen();
      };
      window.addEventListener('scroll', pruefen, { passive: true });
      pruefen();
    }

    /* Les Bebes: die drei Duefte waehlt man in Feldern der App YMQ
       (select.ymq-dropdown, ausserhalb des Formulars, nicht Pflicht). Die
       Leiste schickte nur die Variante ab, ohne YMQ, und auch der Knopf der
       Seite liess leere Felder durch: Bestellung #2564 kam am 25.10.2026 ohne
       Duefte (Otton: "wenn man auf den hier klickt ohne oben auszuwaehlen,
       kann man den in den warenkorb legen"). Jetzt geht nichts in den Korb,
       solange ein Feld leer ist; die Leiste fuehrt dann zum ersten leeren
       Feld und nimmt sonst den Knopf der Seite, damit YMQ die Wahl anhaengt.
       Auf window und in der Einfangphase, damit es vor YMQ und vor dem
       Warenkorb-Skript in theme.liquid laeuft. */
    var ymqFelder = function () { return document.querySelectorAll('select.ymq-dropdown'); };
    var ymqLeer = function () {
      var f = ymqFelder();
      for (var i = 0; i < f.length; i++) if (!f[i].value) return f[i];
      return null;
    };
    var ymqZeigen = function (feld) {
      feld.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        feld.setCustomValidity('Bitte wähle alle drei Düfte.');
        feld.reportValidity();
        feld.addEventListener('change', function () { feld.setCustomValidity(''); }, { once: true });
      } catch (err) {}
    };
    var seitenKnopf = function () {
      var k = document.querySelectorAll('form[action*="/cart/add"] button[name="add"]');
      for (var i = 0; i < k.length; i++) if (!k[i].closest('[data-ml-ks]')) return k[i];
      return null;
    };
    var ymqSperre = function (e) {
      if (!ymqFelder().length) return;
      var ziel = e.target && e.target.closest ? e.target : null;
      if (!ziel) return;
      var ausLeiste = !!ziel.closest('[data-ml-ks]');
      var istKauf = e.type === 'submit'
        ? !!(ziel.matches && ziel.matches('form[action*="/cart/add"]'))
        : !!ziel.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
      if (!istKauf) return;
      var leer = ymqLeer();
      if (leer) {
        e.preventDefault();
        e.stopImmediatePropagation();
        ymqZeigen(leer);
        return;
      }
      if (ausLeiste) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var k = seitenKnopf();
        if (k) k.click();
      }
    };
    window.addEventListener('click', ymqSperre, true);
    window.addEventListener('submit', ymqSperre, true);

    /* Beim Absenden die aktuell gewählte Variante der Seite übernehmen. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('[data-ml-ks]')) return;
      if (duftwahl) {
        e.preventDefault();
        e.stopPropagation();
        var dwForm = duftwahl.querySelector('form');
        var dwKnopf = duftwahl.querySelector('[data-dw-knopf]');
        if (!duftwahl.hasAttribute('data-dw-voll') || !dwForm) {
          duftwahl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (typeof dwForm.requestSubmit === 'function') {
          dwForm.requestSubmit(dwKnopf || undefined);
        } else if (dwKnopf) {
          dwKnopf.click();
        }
        return;
      }
      var feld = form.querySelector('[data-ml-ks-id]');
      var quelle = seitenFormular();
      if (!feld || !quelle) return;
      var gewaehlt = quelle.querySelector('[name="id"]');
      if (gewaehlt && gewaehlt.value) feld.value = gewaehlt.value;
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
